import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import BlackPepperImg from '../assets/banners/black-pepper.avif';
import { FaPepperHot, FaGlobe, FaShieldAlt, FaBox } from 'react-icons/fa';

const BlackPepper = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const [email, setEmail] = useState('');

    const handleEnquiry = () => {
        const subject = encodeURIComponent("Black Pepper Order Enquiry");
        const body = encodeURIComponent(
            `Hi,\n\nI am interested in placing an order or getting a quotation for your Black Pepper.\n\nPlease contact me back at: ${email}\n\nThanks,\n`
        );
        window.location.href = `mailto:yourmail@example.com?subject=${subject}&body=${body}`;
    };

    return (
        <div className="text-gray-800 bg-white">
            {/* Hero Section */}
            <section className="bg-green-100 py-16 px-4 text-center" data-aos="fade-down">
                <h1 className="text-4xl md:text-5xl font-bold text-green-800 mb-4">Premium Black Pepper</h1>
                <p className="text-lg md:text-xl text-gray-700 max-w-2xl mx-auto">
                    Bold, spicy and aromatic — our black pepper is sun-dried and naturally processed for flavor-packed exports.
                </p>
            </section>

            {/* Image and Details Section */}
            <section className="max-w-6xl mx-auto px-4 py-16 grid md:grid-cols-2 gap-10 items-center">
                <div data-aos="zoom-in">
                    <img
                        src={BlackPepperImg}
                        alt="Black Pepper"
                        className="rounded-xl shadow-xl"
                    />
                </div>
                <div data-aos="fade-left">
                    <h2 className="text-3xl font-semibold text-green-800 mb-6">Why Our Black Pepper?</h2>
                    <ul className="space-y-4 text-gray-700">
                        <li className="flex items-start gap-3"><FaPepperHot className="text-green-600 mt-1" />Malabar Garbled, Tellicherry, MG1 & more variants</li>
                        <li className="flex items-start gap-3"><FaShieldAlt className="text-green-600 mt-1" />Rich in Piperine — enhances absorption & immunity</li>
                        <li className="flex items-start gap-3"><FaBox className="text-green-600 mt-1" />Cleaned, graded & double-polished options available</li>
                        <li className="flex items-start gap-3"><FaGlobe className="text-green-600 mt-1" />Exported to 25+ countries — bulk or branded</li>
                        <li className="flex items-start gap-3"><FaPepperHot className="text-green-600 mt-1" />Used in masalas, pickles, marinades, Ayurveda</li>
                    </ul>
                </div>
            </section>

            {/* Specifications Section */}
            <section className="bg-green-50 py-14 px-4" data-aos="fade-up">
                <div className="max-w-5xl mx-auto">
                    <h3 className="text-3xl font-bold text-green-800 text-center mb-10">Product Specifications</h3>
                    <div className="grid md:grid-cols-2 gap-8">
                        <table className="w-full text-sm border border-green-200 rounded-lg shadow-md">
                            <tbody>
                                <tr className="border-b border-green-200">
                                    <th className="p-4 text-left bg-green-100">Variants</th>
                                    <td className="p-4">Malabar Garbled, Tellicherry, MG1, Powder, Crushed</td>
                                </tr>
                                <tr className="border-b border-green-200">
                                    <th className="p-4 bg-green-100">Origin</th>
                                    <td className="p-4">India, Vietnam, Sri Lanka</td>
                                </tr>
                                <tr className="border-b border-green-200">
                                    <th className="p-4 bg-green-100">Shelf Life</th>
                                    <td className="p-4">18 - 24 months</td>
                                </tr>
                                <tr className="border-b border-green-200">
                                    <th className="p-4 bg-green-100">Packaging</th>
                                    <td className="p-4">250g, 500g, 1kg, 25kg, 50kg</td>
                                </tr>
                                <tr>
                                    <th className="p-4 bg-green-100">Moisture</th>
                                    <td className="p-4">Max 12%</td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="w-full text-sm border border-green-200 rounded-lg shadow-md">
                            <tbody>
                                <tr className="border-b border-green-200">
                                    <th className="p-4 text-left bg-green-100">Nutritional Value (per 100g)</th>
                                    <td className="p-4">
                                        Calories: 255 kcal<br />
                                        Protein: 10g<br />
                                        Fat: 3g<br />
                                        Carbs: 64g<br />
                                        Fiber: 27g
                                    </td>
                                </tr>
                                <tr>
                                    <th className="p-4 bg-green-100">Usage</th>
                                    <td className="p-4">
                                        Spice blends, pickles, marinades, Ayurveda, health supplements
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* Quality & Logistics Icons Section */}
            <section className="max-w-6xl mx-auto py-16 px-4 grid md:grid-cols-4 gap-6 text-center" data-aos="fade-up">
                <div>
                    <FaPepperHot className="text-4xl mx-auto text-green-700 mb-2" />
                    <h4 className="font-semibold text-gray-700">Spicy & Aromatic</h4>
                </div>
                <div>
                    <FaShieldAlt className="text-4xl mx-auto text-green-700 mb-2" />
                    <h4 className="font-semibold text-gray-700">Health Booster</h4>
                </div>
                <div>
                    <FaGlobe className="text-4xl mx-auto text-green-700 mb-2" />
                    <h4 className="font-semibold text-gray-700">Global Reach</h4>
                </div>
                <div>
                    <FaBox className="text-4xl mx-auto text-green-700 mb-2" />
                    <h4 className="font-semibold text-gray-700">Safe Packaging</h4>
                </div>
            </section>

            {/* Enquiry Section */}
            <section className="bg-green-100 py-10 px-4" data-aos="fade-up">
                <div className="max-w-xl mx-auto text-center">
                    <h3 className="text-2xl font-bold text-green-800 mb-4">Send Us an Enquiry</h3>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Your Email Address"
                        className="w-full p-3 rounded border border-green-300 mb-4 focus:outline-none"
                    />
                    <button
                        onClick={handleEnquiry}
                        className="bg-green-700 hover:bg-green-800 text-white px-6 py-2 rounded-lg transition-all"
                    >
                        Send Enquiry
                    </button>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default BlackPepper;
